import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { Banner } from '../../../banner';

export const StatusMappingBanner = () => {
  const { t } = useTranslation('analytics');
  const { selectedLocationIds = [] } = useAppScopeStore();
  const { navigate } = useSettingsNavigate();

  const handleNavigateToStatusMappingSettings = () => {
    if (selectedLocationIds.length > 1) {
      navigate({
        to: '/organization/data-sync',
      });
    } else {
      navigate({
        to: '/organization/data-sync/location/:locationId',
        params: {
          locationId: selectedLocationIds[0],
        },
      });
    }
  };

  return (
    <Banner
      buttonLabel={t('Update Mapping')}
      description={t('Map your appointment statuses to keep your data consistent and insights accurate.')}
      iconName='alert-filled'
      styleConfig={{
        backgroundColor: theme.colors.warning5,
      }}
      onButtonClick={handleNavigateToStatusMappingSettings}
      title={t('Improve Appointment Data Accuracy')}
      trackingIdBase='practice-analytics-status-mapping-banner'
    />
  );
};
